export default (urlPrefix?: string) => ({
  projectFetchCryptoDepositMethods: `${urlPrefix}/project-fetchCryptoDepositMethods`,
  userFetchWalletAddresses: `${urlPrefix}/user-fetchWalletAddresses`,
  userFetchBalances: `${urlPrefix}/user-balance`,
  userGenerateNewAddress: `${urlPrefix}/user-generateWalletAddress`,
  userFetchNotifications: `${urlPrefix}/user-fetchUnreadNotifications`
});
